export default ({ shouldRender = false, children }) => {
    let component = null;

    if (shouldRender) {
        component = children;
    }

    return component;
};
